/** A strip slider that gives its items a non-fixed size */
import React from 'react';
import { PapiDeviation } from '@wix/da-types-papi';
import { getDeviationType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { MeasuredSlider } from '@wix/da-shared-react/pkg/Slider';
import { Pages } from '../../../constants';
import { Strip as StripType } from '../../../types/api';
import { getStripType, getItemId, getStripItems } from '../FacetStream/helper';
import StripItem from './StripItem';
import { FacetItemTypes } from '../FacetStream';

export interface Props {
  /** stream data and initial array of content and url pointing to larger collection */
  strip: StripType;
  /** which page is this being displayed on */
  page: Pages;

  className?: string;
  contentClassName?: string;
}

export const MeasuredStripSlider: React.FC<Props> = ({
  strip,
  page,
  className,
  contentClassName,
}) => {
  const type = getStripType(strip);
  const items = getStripItems(strip);
  if (!items) {
    return null;
  }

  const getElementSize = defaultSize => {
    switch (type) {
      case FacetItemTypes.Gallection:
        return { ...defaultSize, height: 340 };
      case FacetItemTypes.Deviation:
        const sampleItem = items[0];
        const deviationType =
          sampleItem && getDeviationType(sampleItem as PapiDeviation);
        if (deviationType === DeviationTypes.COMMISSION) {
          return { ...defaultSize, height: 360 };
        }
        return defaultSize;
      default:
        return defaultSize;
    }
  };

  return (
    <MeasuredSlider
      className={className}
      contentClassName={contentClassName}
      renderSliderItems={defaultSize => {
        const elementSize = getElementSize(defaultSize);
        return items.map((item, index) => (
          <StripItem
            itemIndex={index}
            key={`strip-${type}-${getItemId(item)}`}
            page={page}
            type={type!}
            item={item}
            elementSize={elementSize}
          />
        ));
      }}
    />
  );
};
MeasuredStripSlider.displayName = 'MeasuredStripSlider';

export default MeasuredStripSlider;
